<template>
  <div class="downlaod-page2">
    <van-cell
      clickable
      @click="checkAll"
      class="checkAll"
    >
      <span >全选所有项目</span>
      <template #icon="props">
        <!-- <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" /> -->
        <van-checkbox checked-color="#FF9615" v-model="allcheck"/>
      </template>
    </van-cell>
    <div class="btn">
      <van-button type="default"  @click="gogo" class='up' >批量发送到邮箱</van-button>
      <van-button type="default"  @click="back" class='back' plain color='#0AA8AF'>返回</van-button>
    </div>
    <div class="group-list" style="padding: 5px 10px;">
      <div class="list-item" v-for="(gitem, gindex) in groups" :key="gindex">
        <!-- <van-button :color="themeColor" :icon="gitem.open?'arrow-down':'arrow'" icon-position="right" block size="small" @click="openGroup(gitem, gindex)"></van-button> -->
        <div class="item-info" @click="openGroup(gitem, gindex)">
          <div class="item-title">{{gitem.group}}</div>
          <van-icon :name="gitem.open?'arrow-down':'arrow'" />
        </div>
        <van-checkbox-group v-if="gitem.open" v-model="gitem.result" :ref="'checkboxGroup'+gindex" class='project'>
          <van-cell-group>
            <van-cell
              v-for="(item, index) in gitem.data"
              clickable
              :key="index"
              @click="toggle(item.id, index)"
            >
              <!-- <span @click.stop="showpop(item)">{{item.name}}</span> -->
              <span>{{item.name}}</span>
              <template #icon>
                <van-checkbox :name="item.id" checked-color="#FF9615" ref="checkboxes" />
              </template>
              <div class="right-icon" slot="right-icon" @click.stop="showpop(item)">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#wxicon-icon-download"></use>
                </svg>
              </div>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
    
    <van-popup v-model="showPopup" closeable close-icon-position="top-left" close-icon="clear" class="pdfview">
    <iframe ref="iframe" v-if="document.filepath" :src="'/static/pdfjs/web/viewer.html?file=' + encodeURIComponent(baseUrl+document.filepath)" frameborder="0"></iframe>
      <!-- <div class="page-ft">
        <van-icon name="clear" @click="clear"/>
      </div> -->
    </van-popup>
    <van-dialog v-model="showdialog" title="请输入电子邮箱地址" show-cancel-button @confirm="confirm" @cancel='cancel'>
      <van-cell-group>
        <p class="message">系统自动将资料文件发送至您的邮箱</p>
        <van-field
          v-model="value"
          label="email"
          left-icon="smile-o"
          placeholder="请输入电子邮箱地址"
        />
      </van-cell-group>
    </van-dialog>
  </div>

</template>

<script>
var jweixin = require('jweixin-module')
let hostname = location.hostname;
hostname = hostname.substring(hostname.indexOf('.'));
let appHost = `${location.protocol}//api${hostname}`;
const baseUrl = `${appHost}`;
import {documents, sendEmail} from '../../api/api'
import Vue from 'vue';
import { Popup, Dialog, Toast} from 'vant';

Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Toast);

export default {
  data(){
    return{
      themeColor: this.themeColor,
      content:'',
      column_id: 58, // 本地: 60; 测试: 86; 正式： 58;
      groups: [],
      list:[],
      result:[],
      showPopup: false,
      config_id: window.localStorage.getItem('config_id'),
      document:'',
      baseUrl:baseUrl,
      showdialog: false,
      value:'',
      allcheck:false,
      queryGroup: '',
    }
  },
  created(){
    this.queryGroup = this.$route.query.group
    this.getlist()
  },
  watch: {
    groups: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.groups.length>0) {
          // let cur = this.groups.find(item=>item.open==true)
          // this.list = []
          // this.list = cur.data
        }
      }
    },
  },
  methods:{
    checkAll(index) {
      let isOpen = false
      for(let i in this.groups) {
        let ele = this.groups[i]
        if (ele.open) {
          let k = `checkboxGroup${i}`
          this.$refs[k][0].toggleAll(this.allcheck?false:true);
          isOpen = true
        }
      }
      if (isOpen) {
        this.allcheck = !this.allcheck
      }
    },
    toggle(id, index) {
      for (let i in this.$refs.checkboxes) {
        let ele = this.$refs.checkboxes[i]
        if (ele.name == id) {
          ele.toggle();
        }
      }
    },
    async getlist(){
      await documents({params:{
        config_id : this.config_id,
        sort:'-sortnum'
      }}).then((res)=>{
        // console.log(baseUrl,res.data.items,'res')
        // this.list = []
        // res.data.items.forEach(ele => {
        //   if (this.queryGroup) {
        //     if (this.queryGroup == ele.group) {
        //       this.list.push(ele)
        //     }
        //   } else {
        //     this.list.push(ele)
        //   }
        // });

        let obj = {}
        let arr = []
        res.data.items.forEach(element => {
          if(element.group != '备案表下载' && element.group != '医生备案表下载' && element.group != '资料下载1') {
            if(element.group == '资料下载') element.group = 'Ⅳ期非小细胞肺癌'
            arr.push(element)
          }
        });
        this.groups = []
        for(let i in arr) {
          let ele = arr[i]
          if (!obj[ele.group]) {
            obj[ele.group] = 1
            this.groups.push({
              group: ele.group,
              data: arr.filter(item => item.group == ele.group),
              open: i==0?true:false,
              result: []
            })
          }
        }
      })
    },
    showpop(item){
        this.document = item;
        this.showPopup = true;
        this.$nextTick(()=>{
        let height = document.documentElement.clientHeight || document.body.clientHeight
        let iframe = this.$refs.iframe
        // console.log(this.document.filepath)
        iframe.height =  (height - 44)+'px';
      })
    },
    clear(){
      this.showPopup = false;
    },
    gogo(){
      this.result = []
      let isOpen = false
      for(let i in this.groups) {
        let ele = this.groups[i]
        if (ele.open) {
          this.result = [...this.result,...ele.result]
          isOpen = true
        }
      }
      if (!isOpen) {
        Toast("请至少展开一项！")
        return false
      }
      if(this.result.length === 0){
        Toast('请选择要下载的资料')
        return false
      }
      this.showdialog = true
    },
    confirm(){
      if(!this.value){
        Toast("请输入邮箱地址");
        return false
      }
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if(!reg.test(this.value)){
          Toast("邮箱格式不正确");
          return false
        }
      this.showdialog = false
      // console.log(this.value,this.result)
      sendEmail({
          email: this.value,
          document_ids : this.result
      }).then((res)=>{
          Toast('已发送，请注意查收。')
          this.$wechat.closeWindow()
      }).catch((err)=>{
        Toast(err)
      })
    },
    openGroup(item, index){
      if(item.group.indexOf('敬请期待') != -1) {
        Toast('抱歉，该资料暂未开放下载！')
        return
      }
      if (this.groups[index].open) {
        let k = `checkboxGroup${index}`
        this.$refs[k][0].toggleAll(false)
      }
      this.$nextTick(()=>{
        this.groups[index].open = !this.groups[index].open
        this.allcheck = false
      })
      
    },
    back(){
      this.$wechat.closeWindow()
    },
    cancel(){
      this.value = ''
    }
  }

}
</script>

<style lang="scss" scoped>
  .downlaod-page2 {
    height: 100%;
    width: 100%;
    padding-top: 22px;
    padding-bottom: 118px;
    box-sizing: border-box;
    .project{
      width: 92%;
      margin: 0 auto;
      border-radius: 10px;
      margin-bottom: 20px;
      span{
        color: rgba(16, 16, 16, 1);
        font-size: 16px;
        // font-weight: bold;
        // text-decoration: underline;
        margin-left: 10px;
      }
      .right-icon > .icon {
        width: 2rem; height: 2rem; vertical-align: middle;
      }
    }
    .checkAll{
       width: 92%;
      margin: 0 auto;
      border-radius: 10px;
      span{
        color: rgba(16, 16, 16, 1);
        font-size: 16px;
        // font-weight: bold;
        margin-left: 10px;
      }
    }
    .title{
      font-size: 14px;
      color: #656565;
      padding: 20px;
      box-sizing: border-box;
    }
    .list{
      width: 100%;
      height: 100%;
      .page{
        height:26px;
        padding-left: 30px;
        display:flex;
        color: rgba(145, 145, 145, 1);
        font-size: 16px;
        margin-bottom: 12px;
        line-height: 26px;
        span{
          margin-left: 8px;
          line-height: 30px;
        }
        .left{
           flex: 1;
        }
      }
    }
    .btn{
      position: fixed;
      bottom: 0;
      left: 0;
      background: #F7F8FF ;
      z-index: 99;
      padding-bottom: 20px;
      box-sizing: border-box;
   }
  }
  .page-ft{
     position: fixed;
     top: 10px;
     right: 10px;
  }
  .message{
    font-size: 13px;
     padding:0 20px;
     box-sizing: border-box;
     color: #656565;
     text-align: center;
  }
//  .van-icon-arrow::before {
//      width: 40px;
//      padding-top: 5px;
//   }
</style>
<style lang="less">
.downlaod-page2 {
  .pdfview {
    width: 100%; height:100%; position:absolute;
    iframe {
      width:100%;
    }
    .van-popup__close-icon {
      color: #fff; text-shadow: 0 0 5px rgba(black, 0.3);
    }
  }
  .group-list {
    .list-item {
      margin: 10px;
      .item-info {
        border-radius: 5px; background: @theme-color; color: #fff; display: flex; align-items: center; line-height: 1.5; padding: 8px 15px;
        .item-title {
          flex: 1; min-width: 0; font-size: 15px;
        }
      }
    }
  }
}
</style>